import { formatCount } from "../../../../core/helpers/count-formatting-util.js";
import AbstractFormulaTokenVisitor from "../../../../models/keyFigure/formulaToken/visitors/AbstractFormulaTokenVisitor.js";

/**
 * Visitor that renders formula token labels.
 */
export default class FormulaTokenLabelRenderer extends AbstractFormulaTokenVisitor {
	visitAbstractFormulaToken(_token) {}

	visitAbstractValueFormulaToken(token) {
		return `${token.isCreditPositive() ? "– " : ""}`;
	}

	visitAccountFormulaToken(token) {
		return `${super.visitAccountFormulaToken(
			token,
		)}${token.getAccountNumber()}`;
	}

	visitAccountGroupFormulaToken(token) {
		return `${super.visitAccountGroupFormulaToken(
			token,
		)}${token.getGroupLabel()}`;
	}

	visitAccountIntervalFormulaToken(token) {
		return `${super.visitAccountIntervalFormulaToken(
			token,
		)}${token.getStart()}-${token.getEnd()}`;
	}

	visitKeyFigureFormulaToken(token) {
		return `${super.visitKeyFigureFormulaToken(
			token,
		)}${token.getKeyFigureName()}`;
	}

	visitConstantFormulaToken(token) {
		return `${super.visitConstantFormulaToken(token)}${formatCount(
			token.getValue(),
		)}`;
	}

	visitAdditionFormulaToken(_token) {
		return "+";
	}

	visitSubtractionFormulaToken(_token) {
		return "–";
	}

	visitDivisionFormulaToken(_token) {
		return "/";
	}

	visitMultiplicationFormulaToken(_token) {
		return "×";
	}

	visitOpeningParenthesisFormulaToken(_token) {
		return "(";
	}

	visitClosingParenthesisFormulaToken(_token) {
		return ")";
	}
}
